import {MUTATION_KEYS} from '@/queryClient.ts'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'
import {httpSetPassword} from './auth.http'

type UseSetPasswordOptions = {
    onSuccess?: () => void
    onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useSetPassword = (options?: UseSetPasswordOptions) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.SET_PASSWORD],
        mutationFn: httpSetPassword,
        onError: (error: AxiosError<ErrorResponseData>) => options?.onError?.(error),
        onSuccess: () => options?.onSuccess?.()
    })
